import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Rectangle, ElementEventClick, Stroke } from '../../types';

@Component({
  selector: 'g[svg-rect]',
  templateUrl: './svgrect.component.html',
  styleUrls: ['./svgrect.component.css']
})
export class SvgRectComponent implements OnInit {


  constructor() { }


  @Input()
  public rectangle: Rectangle;

  @Output()
  public rectangleMousedown = new EventEmitter<{ mouseEvent: MouseEvent, rectangle: Rectangle }>();

  ngOnInit() {
    if (!this.rectangle.stroke) {
      this.rectangle.stroke = new Stroke();
    }
  }

  public onRectangleMouseDown($event) {
    if ($event) {
      this.rectangleMousedown.emit({ mouseEvent: $event, rectangle: this.rectangle });
    }
  }
}
